import { GetPackageDetailByTracking } from "api/packages";
import { GetRouteDetail } from "api/routes";
import { GetStationDetailById } from "api/stations";
import { getScanText } from "utils";

// Station a parcel must be scanned at to move along ITS CURRENT route: the next station
// after the parcel's current station in the route navigator. After assigning a customer
// the route can change (the customer's default route wins), so the page's selected
// station may no longer be the right one — the backend scan rejects it with "wrong
// station". Falls back to `selectedStation` whenever this can't be worked out, leaving
// the scan itself to report any problem.
export async function resolveScanStation(tracking, selectedStation) {
  const pkgRes = await GetPackageDetailByTracking(getScanText(tracking));
  if (!pkgRes || pkgRes.status !== 200) return selectedStation;
  const pkg = pkgRes.data;
  if (!pkg.routeId || pkg.routeId === "N/A") return selectedStation;

  const routeRes = await GetRouteDetail(pkg.routeId);
  if (routeRes?.status !== 200) return selectedStation;
  const current = (routeRes.data?.navigator || []).find((n) => n.station === pkg.station);
  const next = current?.nextStation;
  if (!next || next === "END" || next === selectedStation?.id) return selectedStation;

  const stationRes = await GetStationDetailById(next);
  return stationRes?.success ? stationRes.data : selectedStation;
}
